import {Injectable} from "@angular/core";
import {TempWithdrawal, TempWithdrawnStock} from "../../../../store-management/redux/scans.types";
import {WithdrawalReasonInterface} from "../../../../store-management/model/withdrawal-reason-interface.type";
import {WithdrawalConsumerInterface} from "../../../../store-management/model/withdrawal-consumer-interface.type";
import {Observable} from "rxjs/Observable";
import {selectActiveWithdrawal} from "../touch-scan.component";
import {NgRedux} from "@angular-redux/store";
import {WithdrawalActions} from "../../../../store-management/redux/scans.actions";
import {SessionActions} from "../../../../shared/actions/session.actions";
import {Stock} from "../../../../shared/view-model/stock";
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import {MissionFormComponent} from "../../../../mission/mission-form/mission-form.component";
import {MissionInput} from "../../../../mission/model/mission-input.type";
import {AbstractVisbosControl} from "../../../../core/visbos-core/ui/forms/abstract-visbos-control";
import {IAppState} from "../../../../shared/redux-store/store";
import {MissionService} from "../../../../mission/services/mission.service";
import {IUser} from "../../../../shared/redux-store/session/session.types";

@Injectable()
export class TouchScanWizardService {

  currentWithdrawal$: Observable<TempWithdrawal>;

  currentWithdrawal: TempWithdrawal;

  currentConsumer: WithdrawalConsumerInterface;
  currentPersonalNumber: any;
  currentSignature: any;
  currentUser: IUser;
  currentWithdrawalReason: WithdrawalReasonInterface;
  withdrawnStocks: TempWithdrawnStock[];

  missionForm: FormGroup;
  missionForm$: Observable<FormGroup>;

  withdrawalReasonCtrl: FormGroup;
  withdrawalReasonCtrl$: Observable<string>;

  constructor(private wdActions: WithdrawalActions,
              private sessionActions: SessionActions,
              private missionService: MissionService,
              private ngRx: NgRedux<IAppState>,
              private fb: FormBuilder) {

    this.init();

  }

  init() {

    this.withdrawalReasonCtrl = this.fb.group({
      withdrawal_reason_type: ['Einsatz', Validators.required]
    });

    this.withdrawalReasonCtrl$ = this.withdrawalReasonCtrl.get('withdrawal_reason_type').valueChanges;

    this.currentWithdrawal$ = this.ngRx.select(selectActiveWithdrawal);

    this.currentWithdrawal$.subscribe((wd: TempWithdrawal) => {
      if (wd) {
        this.currentWithdrawal = wd;
        this.currentConsumer = wd.consumer;
        this.currentPersonalNumber = wd.personal_number;
        this.currentSignature = wd.signature;
        this.currentUser = wd.authenticated_user;
        this.currentWithdrawalReason = wd.withdrawal_reason;
        this.withdrawnStocks = wd.withdrawn_stocks;

        this.canExitDataPage(); // Required, as missionForm$ only gets subscribed to when the form is shown in the view
        this.canExitArticlePage();

      }
    });

    this.missionForm = MissionFormComponent.initControl(this.fb);
    this.missionForm$ = this.missionForm.statusChanges;
    this.missionForm$.subscribe(mf => {
      this.canExitDataPage();
    });

  }

  createNewWithdrawal() {
    this.wdActions.createNewWithdrawal();
  }

  deselectActiveWithdrawal() {
    this.wdActions.selectWithdrawal(null);
  }

  selectWithdrawalReason(reason_type: string) {
    this.wdActions.selectWithdrawalReason(this.currentWithdrawal.cuid, reason_type);
  }

  addStock(stock: Stock) {
    this.wdActions.addStockToWithdrawal(this.currentWithdrawal.cuid, stock);
  }

  removeStock(stock: Stock) {
    this.wdActions.removeStockFromWithdrawal(this.currentWithdrawal.cuid, stock);
  }

  updateAmount(stock: Stock, amount: number) {
    this.wdActions.setStockAmountForWithdrawal(this.currentWithdrawal.cuid, stock, amount);
  }

  selectConsumer(consumerType: string, consumer: WithdrawalConsumerInterface) {
    this.wdActions.selectConsumer(this.currentWithdrawal.cuid, consumerType, consumer);
  }

  selectUserByPersonalNumber(personalNumber: any, signature: string) {
    this.wdActions.selectUserByPersonalNumber(personalNumber, signature);
  }

  setWithdrawalNote(note: string) {
    this.wdActions.setNote(this.currentWithdrawal.cuid, note);
  }

  saveWithdrawalReason() {

    if (this.currentWithdrawal.withdrawal_reason_type == 'Einsatz' && this.missionForm) {
      let missionInput: MissionInput = this.missionForm.value;

      // Only generate if none exists
      if (!missionInput.cuid) {
        missionInput.cuid = AbstractVisbosControl.cuid();
      }

      this.saveMissionData(missionInput);
    } else {
      this.wdActions.selectWithdrawalReason(this.currentWithdrawal.cuid, this.withdrawalReasonCtrl.get('withdrawal_reason_type').value, null);
      this.missionForm.reset();
    }

  }

  saveMissionData(mission: MissionInput) {
    this.missionService.createMission(mission).subscribe(ms => {
      this.wdActions.selectWithdrawalReason(this.currentWithdrawal.cuid, "Einsatz", ms);
    });
  }

  saveWithdrawal(): Observable<any> {
    return this.wdActions.commitWithdrawals();
  }

  canExitDataPage(): boolean {
    return this.currentConsumer && ((this.currentWithdrawal.withdrawal_reason_type == 'Einsatz' && this.missionForm && this.missionForm.valid) || this.currentWithdrawal.withdrawal_reason_type != 'Einsatz');
  }

  canExitArticlePage(): boolean {
    return this.canExitDataPage() && this.withdrawnStocks && this.withdrawnStocks.length > 0;
  }

  cancelWithdrawal() {
    this.wdActions.cancelWithdrawal(this.currentWithdrawal.cuid);
  }

  hasErrored() {
    return this.ngRx.getState().withdrawals.has_errored ?? false;
  }

}



// WEBPACK FOOTER //
// ./src/app/visbos-touch-client/ui/touch-scan/touch-scan-wizard/touch-scan-wizard.service.ts